var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 8.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 8.5,
    stroke: "#CCCCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6637_43711)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6637_43711)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6637_43711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4996 21.9444C23.6107 21.9444 24.0181 22.1296 24.7218 22.5C25.4255 22.8704 25.7959 23.0926 25.8329 23.1667C25.8329 23.2037 25.8329 23.2593 25.8329 23.3333C25.8329 23.6296 25.7588 23.9444 25.6107 24.2778C25.4996 24.6111 25.2033 24.8889 24.7218 25.1111C24.2403 25.3333 23.8329 25.4444 23.4996 25.4444C23.0181 25.4444 22.2218 25.1852 21.1107 24.6667C20.2959 24.2963 19.5922 23.8148 18.9996 23.2222C18.407 22.6296 17.7959 21.8518 17.1662 20.8889C16.5736 20.037 16.2773 19.2407 16.2773 18.5V18.3889C16.3144 17.6481 16.6292 17 17.2218 16.4444C17.407 16.2593 17.6292 16.1667 17.8885 16.1667C17.9255 16.1667 17.9996 16.1667 18.1107 16.1667C18.2218 16.1667 18.2959 16.1852 18.3329 16.2222C18.481 16.2222 18.5922 16.2407 18.6662 16.2778C18.7403 16.3148 18.7959 16.4259 18.8329 16.6111C18.907 16.7963 19.0551 17.1667 19.2773 17.7222C19.4996 18.2778 19.5922 18.5926 19.5551 18.6667C19.5551 18.8518 19.407 19.0926 19.1107 19.3889C18.8144 19.6852 18.6848 19.8704 18.7218 19.9444C18.7218 20.0185 18.7403 20.0741 18.7773 20.1111C19.0366 20.7407 19.4625 21.3148 20.0551 21.8333C20.4996 22.2778 21.1107 22.6852 21.8885 23.0556C21.9996 23.1296 22.0922 23.1667 22.1662 23.1667C22.3144 23.1667 22.5366 22.963 22.8329 22.5556C23.1292 22.1481 23.3514 21.9444 23.4996 21.9444ZM20.9996 28.5556C22.0366 28.5556 23.0366 28.3518 23.9996 27.9444C24.9625 27.537 25.7959 26.9815 26.4996 26.2778C27.2033 25.5741 27.7588 24.7407 28.1662 23.7778C28.5736 22.8148 28.7773 21.8148 28.7773 20.7778C28.7773 19.7407 28.5736 18.7222 28.1662 17.7222C27.7588 16.7222 27.2033 15.8889 26.4996 15.2222C25.7959 14.5556 24.9625 14.0185 23.9996 13.6111C23.0366 13.2037 22.0366 12.9815 20.9996 12.9444C19.9625 12.9074 18.944 13.1296 17.944 13.6111C16.944 14.0926 16.1107 14.6296 15.444 15.2222C14.7773 15.8148 14.2403 16.6481 13.8329 17.7222C13.4255 18.7963 13.2033 19.8148 13.1662 20.7778C13.1662 22.4444 13.6662 23.963 14.6662 25.3333L13.7218 28.2222L16.7218 27.2222C18.0181 28.1111 19.444 28.5556 20.9996 28.5556ZM20.9996 11.3889C22.2588 11.3889 23.4625 11.6481 24.6107 12.1667C25.7588 12.6852 26.7588 13.3518 27.6107 14.1667C28.4625 14.9815 29.1107 15.963 29.5551 17.1111C29.9996 18.2593 30.2588 19.4815 30.3329 20.7778C30.407 22.0741 30.1477 23.2778 29.5551 24.3889C28.9625 25.5 28.3144 26.4815 27.6107 27.3333C26.907 28.1852 25.907 28.8518 24.6107 29.3333C23.3144 29.8148 22.1107 30.0741 20.9996 30.1111C19.3699 30.1111 17.8514 29.7222 16.444 28.9444L11.2773 30.6111L12.944 25.5556C12.0551 24.1111 11.6107 22.5185 11.6107 20.7778C11.6107 19.4815 11.8699 18.2593 12.3885 17.1111C12.907 15.963 13.5736 14.9815 14.3885 14.1667C15.2033 13.3518 16.1848 12.6852 17.3329 12.1667C18.481 11.6481 19.7033 11.3889 20.9996 11.3889Z",
    fill: "#25D366"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6637_43711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6637_43711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6637_43711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4444,
    height: 20,
    fill: "white",
    transform: "translate(11.2773 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.4ae8f8eb3eda93ca6689fed9b49ed86a.svg";
export { ForwardRef as ReactComponent };